import { EditingFilters, EventFiltersFlyout } from "./EventsFiltersFlyout";
import {
  Header,
  HeaderButton,
  ListItemLabel,
  Shell,
  ViewPort,
} from "bossfotos-design-system";
import {
  FilterKeys,
  useGalleryFilterSearchParams,
} from "../../v2_components/hooks/useGalleryFilterSearchParams";
import {
  formatSessionNameForURL,
  isWindowInIframe,
  replaceDashesWithSpaces,
  setGalleryNavBackButtonUrl,
} from "../../v2_actions/nav";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// @ts-ignore
import { NotificationContainer } from 'react-notifications'
import 'react-notifications/lib/notifications.css'
import { ActiveFilterPills } from "./ActiveFilterPills";
import { BOSSFOTOS_INFO_WEBSITE } from "../../v2_actions/routes";
import CollectionsIcon from "@mui/icons-material/Collections";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import FaceIcon from "@mui/icons-material/Face";
import ContextMenu from "../../v2_components/layout/ContextMenu";
import DesktopEventList from "../../v2_components/eventpage/DesktopEventList";
import { EventFiltersBroker } from "../../v2_components/hooks/useEventFiltersBroker";
import { GalleryMap } from "../../v2_components/GalleryMap";
import LoadingHorseShoe from "../../design-system/layouts/LoadingHorseShoe";
import { NavBar } from "./NavBar";
import PlaceIcon from "@material-ui/icons/Place";
import { SearchBarAny } from "./SearchBarAny";
import { SearchBarLocation } from "./SearchBarLocation";
import { briefGalleryList } from "../../v2_actions/brief_gallery";
import { makeLogger } from "../../utils/o11y/logger";
import styles from "./Events.module.css";
import { useEventsPageStartupEffects } from "../../v2_components/hooks/useEventsPageStartupEffects";
import { useReduxStateReconcilation } from "../../v2_components/hooks/useReduxStateReconcilation";
import { useRouteInfo } from "../../v2_components/hooks/useRouteInfo";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ReusableTabs from "../../v2_components/TabPanel";
import AlbumFacialRecognition from "../../v2_components/AlbumFacialRecognition";

const logger = makeLogger({
  enabled: true,
  label: "MobileEvents",
  color: "red",
});

const MobileAlbum = () => {
  const isLoading = useEventsPageStartupEffects();

  if (isLoading) {
    return <LoadingHorseShoe />;
  }

  return <MobileEventsInner />;
};

/**
 * Events screen component
 * @returns
 */
const MobileEventsInner = () => {
  const isInIframe = isWindowInIframe();
  useReduxStateReconcilation();
  const navigate = useNavigate();
  const { isMapView, eventsUrlPath } = useRouteInfo();
  const { gallery_event_name, album_name } = useParams();
  const [
    galleryFilterSearchParams,
    syncGalleryFilterSearchParams,
    urlSearchParams,
  ] = useGalleryFilterSearchParams();
  const albumNameForAPI = replaceDashesWithSpaces(album_name);

  const [filterFlyoutActive, setFiltersFlyoutActive] = useState(false);
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [expandActiveMobileTabFilter, setExpandActiveMobileTabFilter] = useState(true);
  const [isFacialRecognitionFilterActive, setIsFacialRecognitionFilterActive] = useState(false);
  const [clearFiltersWasClicked, setClearFiltersWasClicked] = useState(false);

  setGalleryNavBackButtonUrl();

  const isMapFilterActive = briefGalleryList.isMapFilterActive();

  // are filters active? exclude search (visible) and country (permanent)
  const hasActivefilters =
    Object.keys(galleryFilterSearchParams).filter(
      (k) =>
        galleryFilterSearchParams[k as FilterKeys] !== undefined &&
           k !== "any",
    ).length > 0 ||
    !!gallery_event_name ||
    (!isMapView && isMapFilterActive);

  const showFilterSummary = (isMapView && hasActivefilters) || !isMapView;

  logger.log({
    hasActivefilters,
    galleryFilterSearchParams,
    isMapFilterActive,
  });

  const handleFilterClicked = () => {
    setFiltersFlyoutActive(true);
  };

  const handleFilterFlyoutClose = () => {
    setFiltersFlyoutActive(false);
  };
  const handleMenuClicked = () => {
    setShowContextMenu(true);
  };
  const handleHelpClicked = () => {
    window.open(`${BOSSFOTOS_INFO_WEBSITE}/info-centre/`);
  };

  const handleFilterFlyoutShowResults = (
    editedFilters: Partial<EditingFilters>,
  ) => {
    setFiltersFlyoutActive(false);
    logger.log({ editedFilters });

    if (editedFilters.event !== gallery_event_name) {
      const newParams = syncGalleryFilterSearchParams({
        date: editedFilters.date,
        activity: editedFilters.activity,
        country: editedFilters.country,
        photographers: editedFilters.photographers,
      });
      const redirectUrl = `/customer/events/${formatSessionNameForURL(editedFilters.event)}?${newParams}`;
      navigate(redirectUrl);
    } else {
      syncGalleryFilterSearchParams({
        date: editedFilters.date,
        activity: editedFilters.activity,
        photographers: editedFilters.photographers,
      });
    }
  };

  const formattedName = replaceDashesWithSpaces(album_name ? album_name : gallery_event_name)
  const isAlbumPage = !!album_name

  const mobileTabPanelColumns = [
    {
      icon: <FaceIcon />,
      title: "Facial Recognition",
    },
  ];

  const renderFacialRecognitionFilter = () => {
    return (
      <Stack direction={{ xs: "column", sm: "row" }}>
        <AlbumFacialRecognition
          albumNameForAPI={albumNameForAPI}
          clearFiltersWasClicked={clearFiltersWasClicked}
          setClearFiltersWasClicked={setClearFiltersWasClicked}
          setExpandActiveMobileTabFilter={setExpandActiveMobileTabFilter}
          setIsFacialRecognitionFilterActive={setIsFacialRecognitionFilterActive}
        />
      </Stack>
    );
  };  

  const renderMobileGalleryPhotographsParentView = () => {
    return (
      <Box>
        <ReusableTabs
          scrollButtons
          variant="scrollable"
          columns={mobileTabPanelColumns}
          expandActiveMobileTabFilter={expandActiveMobileTabFilter}
          setExpandActiveMobileTabFilter={setExpandActiveMobileTabFilter}
          rows={[
            renderFacialRecognitionFilter(),
            <p>Other Filters</p>,
          ]}
        />
      </Box>
    );
  };  

  return (
    <ViewPort>
      <Shell>
        <NotificationContainer />
        <ContextMenu
          showContextMenu={showContextMenu}
          setShowContextMenu={setShowContextMenu}
        />
        {!isInIframe && (
          <NavBar
            onMenuClicked={handleMenuClicked}
            onHelpClicked={handleHelpClicked}
            event_album_name={formattedName}
            showBackButton={isAlbumPage}
          />
        )}
        {renderMobileGalleryPhotographsParentView()}
        <div className={`${styles.padded}`}></div>
        <div
          data-testid="legacy-mobile-eventlist-wrapper"
          className={`${styles.legacymobileeventlistwrapper} legacymobileeventlistwrapper`}
        >
          {isMapView ? (
            <>
            <EventFiltersBroker
              albumUrlKey={album_name}
              galleryEventUrlKey={gallery_event_name}
              event_page={undefined}
            />
            <GalleryMap />
            </>
          ) : (
            <DesktopEventList
              album_name={replaceDashesWithSpaces(album_name)}
              gallery_event_name={replaceDashesWithSpaces(gallery_event_name)}
            />
          )}
        </div>
      </Shell>
    </ViewPort>
  );
};

export default MobileAlbum;
